document.addEventListener('DOMContentLoaded', function () {
  const radios = document.querySelectorAll('input[data-card-radio]');

  // ✅ Uncheck all radios on page load
  radios.forEach(function (radio) {
    radio.checked = false;
  });

  // ✅ Add event listeners for radio change
  radios.forEach(function (radio) {
    radio.addEventListener('change', function () {
      const label = document.querySelector(`label[for="${radio.id}"]`);
      if (!label) return;

      const newImageSrc = label.getAttribute('data-img-src');
      if (!newImageSrc) return;

      const cardWrapper = radio.closest('[data-card-prd-id]');
      if (!cardWrapper) return;

      const cardId = cardWrapper.getAttribute('data-card-prd-id');
      const imgEl = cardWrapper.querySelector('.card__media img');

      if (imgEl) {
        imgEl.src = newImageSrc;
        imgEl.srcset = `${newImageSrc}&width=165 165w, ${newImageSrc}&width=360 360w, ${newImageSrc}&width=533 533w, ${newImageSrc} 650w`;
      }
    });
  });
});
